import { useRef, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import useRevealMotion from '@/hooks/useRevealMotion';
import usePageTransition from '@/hooks/usePageTransition';

export default function SiteLayout({ children }: { children: ReactNode }) {
  const mainRef = useRef<HTMLElement>(null);
  const footerRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  useRevealMotion(mainRef, pathname);
  usePageTransition([mainRef, footerRef], pathname);
  return (
    <div className="bg-background-50 text-foreground-950 overflow-x-clip">
      <Header />
      <main ref={mainRef} className="pt-[72px]">{children}</main>
      <div ref={footerRef}><Footer /></div>
    </div>
  );
}